import { render, staticRenderFns } from "./Toolbar2_company.vue?vue&type=template&id=ae562612&scoped=true&"
import script from "./Toolbar2_company.vue?vue&type=script&lang=js&"
export * from "./Toolbar2_company.vue?vue&type=script&lang=js&"
import style0 from "./Toolbar2_company.vue?vue&type=style&index=0&id=ae562612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae562612",
  null
  
)

export default component.exports